const api = '/api/v1/u014_p_discount_controller.php';
import axios from 'axios';
export const p_discount_repository =  {
    get(sell_id){
        return  axios.get(`${api}?SELL_ID=${sell_id}`);
    },
    upd(data){
        return  axios.post(api, data);
    }
};

